import { ICatalogueExamenWebServiceClient } from "@resources/resources";
import { Injectable } from "@angular/core";
import { AbstractLoadingResolver, WaitingModalService } from "@digicerba/common";

@Injectable()
export class ExamenResolver extends AbstractLoadingResolver {

  constructor(waitingModal : WaitingModalService, private examenWebservice: ICatalogueExamenWebServiceClient) {
    super(waitingModal);
  }

  doResolve() {
    return this.examenWebservice.catalogueExamenFiltre();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/catalogue-examens/examens.resolver.ts